<template>
  <div class="filtrate">
    <ul class="filtrate-border">
      <li class="filtrate-strong">题型 :</li>
      <li
        class="filtrate-text pointer"
        :class="{'active': questionNumber === -1}"
         @click="onChangeList('questionType', -1)"
      >全部</li>
      <li
        class="filtrate-text pointer filtrate-dot"
        v-for="(item, index) in questionType"
        :class="{'active': questionNumber === item.questionType}"
        :key="index"
        @click="onChangeList('questionType', item.questionType)"
      >{{item.name}}</li>
    </ul>
    <ul class="filtrate-dotted pointer">
      <li class="filtrate-strong">题目难度
          <el-popover
            placement="top-start"
            title="题目难度说明"
            width="150"
            trigger="hover">
            <img slot="reference" src="../../images/question-mark.png">
              10 ~ 30 <span style="margin-left: 10px">简单题目</span>
              <br>
              40 ~ 60 <span style="margin-left: 10px">中等难度题目</span>
              <br>
              70 ~ 90 <span style="margin-left: 10px">较难题目</span>
          </el-popover> :
      </li>
      <li
        class="filtrate-text pointer"
        :class="{'active': difficultyNumber === -1}"
        @click="onChangeList('difficultyLevel', -1)"
      >全部</li>
      <li
        class="filtrate-text filtrate-dot pointer"
        v-for="(kitem, index) in difficultyLevel"
        :key="index"
        :class="{'active': difficultyNumber === kitem}"
        @click="onChangeList('difficultyLevel', kitem)"
      >{{kitem}}</li>
    </ul>
    <div class="filtrate-knowledge" id="knowledge" v-if="fromPage">
      <div class="filtrate-strong box">知识点范围 :</div>
      <ul id="more">
        <li
          class="filtrate-text pointer"
          :class="{'active': knowledgeNumber === -1}"
          @click="onChangeList('knowledgeScope', -1)"
        >全部</li>
        <li
          class="filtrate-text filtrate-dot pointer"
          :class="{'active': knowledgeNumber === item.knowledge_code}"
          v-for="(item, index) in knowledgeScope"
          :key="index"
          @click="onChangeList('knowledgeScope', item.knowledge_code)"
        >{{item.knowledge_name}}</li>
      </ul>
      <div class="filtrate-more pointer" @click="open" v-if="moreType && !moreShow">
        展开更多
        <i class="el-icon-arrow-down"></i>
      </div>
      <div class="filtrate-more pointer" @click="close" v-if="!moreType && !moreShow">
        收起展示
        <i class="el-icon-arrow-up"></i>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { getKnowledgeList, getQuestionListByCombinInfo } from '@/api/pt';
import { getSign } from '@/utils';

export default {
  name: 'Filtrate',
  props: {
    page: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    course: {
      type: Object,
      default: () => ({}),
    },
    fromPage: {
      type: Number,
      default: 1,
    }
  },
  data() {
    return {
      questionType: [
        { name: '单选题', questionType: 1 },
        { name: '多选题', questionType: 2 },
        { name: '填空题', questionType: 3 },
        { name: '判断题', questionType: 4 },
      ],
      questionNumber: -1,
      difficultyLevel: [10, 20, 30, 40, 50, 60, 70, 80, 90],
      difficultyNumber: -1,
      knowledgeScope: [],
      knowledgeNumber: -1,
      KnowledgeCode: '',
      moreType: true,
      moreShow: false,
      hoverShow: false,
      timer: null,
    };
  },
  mounted() {
    this.getKnowledge();
  },
  watch: {
    knowledgeScope() {
      this.$nextTick(() => {
        console.log('mo', document.getElementById('more').offsetHeight);
        if (document.getElementById('more').offsetHeight < 40) {
          console.log(111,document.getElementById('more').offsetHeight );
          this.moreShow = true;
        } else {
          this.moreShow = false;
        }
      })
    },
    pageSize(newval) {
      this.getQuestionListByCombinInfo(
        this.knowledgeNumber,
        this.difficultyNumber,
        this.questionNumber,
        this.page,
        newval,
      );
    },
    page(val) {
      this.getQuestionListByCombinInfo(
        this.knowledgeNumber,
        this.difficultyNumber,
        this.questionNumber,
        val,
        this.pageSize,
      );
    },
    'course.lessonId': function () {
      this.getKnowledge();
      this.$emit('amendPagination', 1, 10)
    },
    'course.chapterId': function () {
      this.getKnowledge();
      this.$emit('amendPagination', 1, 10)
    },
  },
  methods: {
    open() {
      document.getElementById('knowledge').style.height = `${document.getElementById('more').offsetHeight + 20}px`;
      this.moreType = false;
    },
    getKnowledge() {
      const param={
        chapter_id: this.course.chapterId,
        lesson_id: this.course.lessonId,
        textbook_id: this.course.textbookId,
        course_id: this.course.courseTreeId,
      };
      param.sign = getSign(param);
      getKnowledgeList(param).then(({ data }) => {
        this.knowledgeScope = data;
        const knowledgeList = [];
        this.knowledgeScope.map((item) => {
          knowledgeList.push(item.knowledge_code);
          return knowledgeList;
        });
        this.KnowledgeCode = knowledgeList.join(',');
        this.getQuestionListByCombinInfo();
        // this.$store.commit('CLEAR_QUESTIONS_BASKET', []);
      });
    },
    close() {
      this.moreType = true;
      document.getElementById('knowledge').style.height = '63px';
    },
    async getQuestionListByCombinInfo(
      knowledgeNumber = -1,
      difficultyNumber = -1,
      questionNumber = -1,
      page = 1,
      pageSize = 10,
    ) {
      if (knowledgeNumber === -1) {
        this.knowledgeNumber = -1;
      }
      let codes = this.knowledgeNumber;
      if (codes === -1) {
        codes = (this.knowledgeScope || []).map(item => item.knowledge_code).join(',')
      }
      const param = {
        knowledge: codes,
        difficulty: difficultyNumber,
        subject_id: this.course.subjectId,
        question_type: questionNumber,
        page,
        page_size: pageSize,
      };
      param.sign = getSign(param)
      const res = await getQuestionListByCombinInfo(param);
      this.$emit('getQuestion', res.data);
    },
    onChangeList(value, item) { // 切换
      if (value === 'questionType') {
        this.questionNumber = item;
        this.getQuestionListByCombinInfo(
          this.knowledgeNumber,
          this.difficultyNumber,
          this.questionNumber,
          1,
          10,
        );
        this.$emit('amendPagination', 1, 10)
      }
      if (value === 'difficultyLevel') {
        this.difficultyNumber = item;
        this.getQuestionListByCombinInfo(
          this.knowledgeNumber,
          this.difficultyNumber,
          this.questionNumber,
          1,
          10,
        );
        this.$emit('amendPagination', 1, 10)
      }
      if (value === 'knowledgeScope') {
        this.knowledgeNumber = item;
        this.getQuestionListByCombinInfo(
          this.knowledgeNumber,
          this.difficultyNumber,
          this.questionNumber,
          1,
          10,
        );
        this.$emit('amendPagination', 1, 10)
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .filtrate {
    background: #FFFFFF;
    margin-bottom: 60px;
    border-radius: 2px;
    .box {
      position: absolute;
      top: 22px;
      left: 64px;
    }
    #more {
        position: absolute;
        left: 144px;
        top: 14px;
        line-height: 38px;
      }
    &-strong {
      width: 96px;
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      text-align: end;
      color: #000000;
      img {
        width: 16px;
        height: 16px;
        vertical-align: middle;
      }
    }
    .active {
      border-radius: 5px;
      color: #FFFFFF;
      background-color: #1989FA;
      &:hover {
        color: #fff !important;
      }
    }
    ul {
      margin-left: 40px;
      line-height: 66px;
      li {
        line-height: 24px;
        padding: 7px 12px;
        display: inline-block;
        margin: 0 12px;
        cursor: pointer;
      }
    }
    &-knowledge {
      // display: flex;
      // justify-content: space-around;
      position: relative;
      overflow: hidden;
      height: 63px;
      ul {
        width: 75%;
        margin-right: 10px;
      }
    }
    &-text {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #303133;
    }
    &-dot {
      line-height: 24px;
      &:hover {
        color: rgba(25, 137, 250, 1);
      }
    }
    &-border {
      border-bottom: 1px solid #DCE1EB;
    }
    &-dotted {
      border-bottom: 1px dotted #DCE1EB;
    }
    &-more {
      position: absolute;
      right: -24px;
      top: 24px;
      width: 100px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #1989FA;
      line-height: 14px;
     & /deep/ .el-icon-arrow-up:before {
       content: '\e6e1'
     }

    }
  }
</style>
